import React, { useState } from "react"
import Carousel from "@bappweb/carousel"
import Page from "@smpu-web/globalmodules/page"
import InfoBox from "../infobox"
import "./assets/style.scss"

const Campaign = (props) => {
  const [campaigns] = useState(props.data)
  const carouselInfo = () => {
    return campaigns.map((campaign) => {
      return (
        <InfoBox
          key={campaign.id}
          id={"infobox" + campaign.id}
          img={campaign.image}
          text1={campaign.name}
          text2={campaign.description}
        />
      )
    })
  }

  return (
    <Page padding={false}>
      <Carousel
        slidesToShow={3}
        slidesToScroll={2}
        infinite={false}
        arrows={false}
        autoplay={false}
        focusOnSelect={false}
        variableWidth={true}
        dots={false}
        vertical={false}
        adaptiveHeight={false}
        centerMode={true}>
        {campaigns && carouselInfo()}
      </Carousel>
    </Page>
  )
}

export default Campaign
